import React from 'react'
import PoolList from '../../../Components/PoolList/PoolList'
import Title from '../../../Components/Title/Title'
import UpperTitle from '../../../Components/UpperTitle/UpperTitle'

const StandardList = () => {
    return (
        <section id="pools-standard-list" className='sections-spacing'>
            <div className='container-main'>
                <UpperTitle title={"LISTS"} />
                <Title title={"Standard pools"} punctuation={"."} color={"#323232"} spacing={"big"} />

                <PoolList
                    theme="green"
                    risk="low"
                    riskTitle="LOW RISK POOL"
                    bigNumber="2.121556"
                />
                <PoolList
                    theme="orange"
                    risk="med"
                    riskTitle="MEDIUM RISK POOL"
                    bigNumber="2.121556"
                />
                <PoolList
                    theme="red"
                    risk="hi"
                    riskTitle="HIGH RISK POOL"
                    bigNumber="2.121556"
                />

            </div>
        </section>
    )
}

export default StandardList